<template>
  <NavigationComponent :activeTag="$t('app_features.live')">
    <CameraItemLayout>
      <template #contentLeft>
        <div>
          <div v-if="loading" class="loadingCard is-loading pt-4">
            <div
              class="image group block w-full aspect-w-4 aspect-h-3 bg-gray-50 overflow-hidden"
            />
          </div>
        </div>
        <LiveBase :cameraId="$route.params.camera_id" />
      </template>
    </CameraItemLayout>
  </NavigationComponent>
  <LiveSwitch class="fixed lg:absolute live-container right-5 z-10" />
</template>

<script>
import { segmentAnalytics } from "@/assets/scripts";
import NavigationComponent from "@/components/layout/NavigationComponent.vue";
import LiveBase from "@/components/live_video/LiveBase.vue";
import LiveSwitch from "@/components/live_video/LiveSwitch.vue";
import CameraItemLayout from "@/views/camera/components/CameraItemLayout.vue";

export default {
  name: "Live",
  components: {
    LiveSwitch,
    NavigationComponent,
    CameraItemLayout,
    LiveBase,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    segmentAnalytics("Live Visit");
  },
};
</script>

<style scoped>
.live-container {
  top: 18px;
}

@media (min-width: 1024px) {
  .live-container {
    top: 16px;
  }
}
</style>
